import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class SharingService {

    options: any;

    number = 0;
    base_Url: any;
    apiKey: any;
    companyId: any;


    private signImg = new BehaviorSubject<any>('');
    signatureData = this.signImg.asObservable();


    constructor(public http: HttpClient) {


    }

    getbaseurl(baseurl: any) {
        this.base_Url = baseurl;
    }



    getData(url: any) {
        this.options = {
            headers: new HttpHeaders({
                'X-Authorization': this.apiKey,
                'X-Company': this.companyId
            })
        };
        let apiUrl = this.base_Url + url;
        return this.http.get(apiUrl).pipe(map(res => res));
    }
    postData(url: any, body: any) {
        // this.options = {
        //   headers: new HttpHeaders({
        //     'X-Authorization': this.apiKey,
        //     'X-Company': this.companyId
        //   })
        // };
        let apiUrl = this.base_Url + url;
        return this.http.post(apiUrl, body).pipe(map(res => res));
    }
    putData(url: any, body: any) {
        this.options = {
            headers: new HttpHeaders({
                'X-Authorization': this.apiKey,
                'X-Company': this.companyId
            })
        };
        let apiUrl = this.base_Url + url;
        return this.http.put(apiUrl, body, this.options)
    }

}
